import React from 'react';
import { Navigate } from 'react-router-dom';

interface PrivateRouteProps {
  children: React.ReactNode;
  isAuthenticated: boolean;
  allowedRoles: string[];
  userRole: string | null;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({
  children,
  isAuthenticated,
  allowedRoles,
  userRole
}) => {
  const normalizeRole = (role: string) => role?.trim().toLowerCase();
  const normalizedRole = userRole ? normalizeRole(userRole) : null;
  const normalizedAllowedRoles = allowedRoles.map(role => normalizeRole(role));

  // If user is not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // If user role is not allowed, redirect to homepage or dashboard
  if (normalizedRole && !normalizedAllowedRoles.includes(normalizedRole)) {
    // Redirect based on role
    if (normalizedRole === 'owner' || normalizedRole === 'super admin') {
      return <Navigate to="/owner/dashboard" replace />;
    } else {
      return <Navigate to="/admin/dashboard" replace />;
    }
  }

  // If user is authenticated and has the right role, render the children
  return <>{children}</>;
};

export default PrivateRoute; 